import 'reflect-metadata';
import { singleton } from 'tsyringe';
import axios from 'axios';
import FileSaver from 'file-saver';
import { ContentType } from '@/Domain';

@singleton()
export class FileService {
    async 上传(Url: string, File: Blob | Uint8Array, contentType: ContentType): Promise<void> {
        await axios.put(Url, File, {
            headers: {
                'Content-Type': contentType,
            },
        });
    }

    async 获取文件到dataUrl(Url: string): Promise<string> {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise<string>(async (resolve, reject) => {
            try {
                const arrayBuffer = await this.获取文件到ArrayBuffer(Url);
                const reader = new FileReader();
                const blob = new Blob([arrayBuffer]);
                reader.onload = (e) => {
                    if (e.target === null) return;
                    resolve(e.target.result as string);
                };
                reader.onerror = (e) => {
                    reject({ error: e, message: '转换文件到DataUrl出错' });
                };
                reader.readAsDataURL(blob);
            } catch (e) {
                reject(e);
            }
        });
    }

    async 获取文件到ArrayBuffer(Url: string): Promise<ArrayBuffer> {
        const res = await fetch(Url);
        if (res.status === 200) return await res.arrayBuffer();
        else
            throw {
                code: res.status,
                message: res.statusText,
                url: Url,
            };
    }

    async 获取文件到<T>(Url: string): Promise<T> {
        const res = await fetch(Url);
        const promise = res.json();
        return promise as Promise<T>;
    }

    async 获取文件到Buffer(Url: string): Promise<Buffer> {
        const arrayBuffer = await this.获取文件到ArrayBuffer(Url);
        const buffer = Buffer.alloc(arrayBuffer.byteLength);
        const view = new Uint8Array(arrayBuffer);
        for (let i = 0; i < buffer.length; ++i) {
            buffer[i] = view[i];
        }
        return buffer;
    }

    async 获取文件到Uint8Array(Url: string): Promise<Uint8Array> {
        return new Uint8Array(await this.获取文件到ArrayBuffer(Url));
    }

    另存为(content: Blob | Uint8Array, fileName: string) {
        if (content instanceof Blob) FileSaver.saveAs(content, fileName);
        if (content instanceof Uint8Array) FileSaver.saveAs(new Blob([content]), fileName);
    }
}
